module.exports = __webpack_public_path__ + "img/pitch.c0f195e1.svg";